<template>
  <v-app class="fundo">
    <v-container class="fill-height" fluid>
      <v-row align="center" class="mb-12 mt-n12" justify="center">
        <v-card class="borda" width="600">
          <v-card-text>
            <!-- FORMULÁRIO DE LOGIN -->
            <v-row v-if="!loadingValidSlug && validSlug">
              <v-col md="6">
                <v-row justify="center">
                  <v-img max-width="60%" src="../assets/Group.png" />
                </v-row>
                <v-row class="fil-height flex-column ma-0">
                  <v-col class="text-center">
                    <span
                      v-if="!recuperarSenhaBoolean"
                      class="black--text title font-weight-bold"
                    >Bem-Vindo!</span>
                  </v-col>
                  <v-col class="mt text-center">
                    <v-avatar size="100" tile v-if="clube.clube_logotipo">
                      <v-img
                        height="100"
                        contain
                        :src="clube.clube_logotipo"
                        :lazy-src="clube.clube_logotipo"
                      />
                    </v-avatar>
                    <v-avatar size="100" color="#283480" v-if="!clube.clube_logotipo">
                      <span
                        class="white--text headline text-uppercase"
                      >{{clube.clube_nome_comercial.charAt(0)}}</span>
                    </v-avatar>
                  </v-col>
                  <!-- <v-col class="mt-3 text-center">
                    <v-btn rounded class="white--text" to="/" color="#283480">Criar conta</v-btn>
                  </v-col>-->
                </v-row>
              </v-col>
              <v-col md="6">
                <span
                  v-if="!recuperarSenhaBoolean"
                  class="black--text headline font-weight-bold"
                >Primeiro Login</span>
                <span v-else class="black--text headline font-weight-bold">Recuperar senha</span>
                <br />

                <span
                  v-if="!recuperarSenhaBoolean"
                  class="black--text"
                >Crie uma senha para sua conta e efetue o login para acessar o sistema</span>
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="login()"
                  v-if="!recuperarSenhaBoolean "
                >
                  <v-text-field
                    class="mb-n4 mt-5"
                    dense
                    solo
                    flat
                    outlined
                    type="email"
                    label="E-mail"
                    name="email"
                    required
                    v-model="form.usuario_email"
                  ></v-text-field>
                  <v-text-field
                    :rules="rules"
                    label="Crie uma senha"
                    name="senha"
                    v-model="form.usuario_senha"
                    @click:append="ver_senha()"
                    :type="senha"
                    solo
                    :append-icon="senha_icone"
                    dense
                    flat
                    outlined
                  ></v-text-field>
                  <v-btn
                    color="#283480"
                    rounded
                    class="white--text mt-n2"
                    :disabled="loading"
                    :loading="loading"
                    @click="login()"
                    v-if="!recuperarSenhaBoolean"
                  >Salvar e Entrar</v-btn>
                  <v-btn
                    color="#283480"
                    rounded
                    class="white--text mt-n2"
                    :disabled="loading"
                    :loading="loading"
                    @click="mudarSenha()"
                    v-else
                  >Enviar</v-btn>
                  {{errorMessage}}
                </v-form>
                <v-form ref="form" v-model="valid" @submit.prevent="mudarSenha()" v-else>
                  <v-text-field
                    class="mb-n4 mt-5"
                    dense
                    solo
                    flat
                    outlined
                    type="email"
                    label="E-mail"
                    name="email"
                    required
                    v-model="form.usuario_email"
                  ></v-text-field>
                  <v-text-field
                    label="Crie uma senha"
                    name="senha"
                    v-model="form.usuario_senha"
                    @click:append="ver_senha()"
                    :type="senha"
                    solo
                    :rules="rules"
                    :append-icon="senha_icone"
                    dense
                    flat
                    required
                    outlined
                  ></v-text-field>
                  <v-btn
                    color="#283480"
                    rounded
                    class="white--text mt-n2"
                    :disabled="loadingNovaSenha"
                    :loading="loadingNovaSenha"
                    type="submit"
                  >Enviar</v-btn>
                  {{errorMessage}}
                </v-form>
              </v-col>
            </v-row>

            <!-- CLUBE NÃO ENCONTRADO -->
            <v-row v-if="!loadingValidSlug && !validSlug" class="py-10 text-center">
              <v-col md="12" class="text-center">
                <label>Clube não encontrado.</label>
              </v-col>
            </v-row>

            <!-- LOADING VALIDAR SLUG-->
            <v-row v-if="loadingValidSlug" class="py-10 text-center">
              <v-col md="12" class="text-center">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";

export default {
  props: ["clubeSlug"],
  data() {
    return {
      form: {
        usuario_email: "",
        usuario_senha: ""
      },
      senha_icone: "mdi-18px mdi-eye",
      senha: "password",
      loadingNovaSenha: false,
      errorMessage: "",
      user: "",
      loading: false,
      loadingContinuar: false,
      loadingValidSlug: true,
      dialog_clubes: false,
      dialog_termos: false,
      validSlug: false,
      clube: {
        clube_logotipo: "",
        clube_nome_comercial: ""
      },
      valid: true,
      rules: [
        v => !!v || "Campo obrigatório.",
        v => v.length >= 6 || "Mínimo 6 caracters"
      ],
      recuperarSenhaBoolean: false
    };
  },

  created() {
    if (this.clubeSlug) {
      this.validarSlug();
    } else {
      this.loadingValidSlug = false;
      this.validSlug = false;
      this.clube = "";
    }
    if (this.$route.path.substr(0, 3) == "/r/") {
      this.recuperarSenhaBoolean = true;
    }
    if (this.$route.params.userToken) {
      this.getUserByToken();
    } else {
      location.href("https://meuclube.net.br");
    }
  },

  methods: {
    close() {
      this.dialog_clubes = false;
    },
    ver_senha() {
      if (this.senha == "password") {
        this.senha = "";
        this.senha_icone = "mdi-18px mdi-eye-off";
      } else {
        this.senha = "password";
        this.senha_icone = "mdi-18px mdi-eye";
      }
    },

    getUserByToken() {
      this.loading = true;
      Api.post("/getuser", { token: this.$route.params.userToken })
        .then(response => {
          this.loading = false;
          if (response.data.error) {
            this.$toast.error(response.data.error);
            location.href("https://meuclube.net.br");
          } else {
            this.form.usuario_email = response.data.usuario_email;
          }
        })
        .catch(err => {
          this.loading = false;
          location.href("https://meuclube.net.br");
          throw err;
        });
    },

    mudarSenha() {
      if (this.$refs.form.validate()) {
        this.loadingNovaSenha = true;
        let post = {
          usuario_senha: this.form.usuario_senha,
          usuario_token: this.$route.params.userToken
        };
        Api.post(`/mudar-senha`, post)
          .then(response => {
            this.loadingValidSlug = false;
            if (response.data.error) {
              this.loadingNovaSenha = false;
              this.$toast.warning(response.data.error);
            } else {
              this.$toast.success(response.data.success);
              setTimeout(() => {
                this.$toast.info("Redirecionando para Login");
              }, 1000);
              setTimeout(() => {
                let route = this.$route.params.clubeSlug;
                this.$router.replace({
                  name: "Login",
                  params: { clubeSlug: route }
                });
              }, 3000);
            }
          })
          .catch(err => {
            this.loadingNovaSenha = false;
            this.loadingValidSlug = false;
            this.clube = "";
            throw err;
          });
      }
    },
    continuarTermos() {
      Api.post(`/usuario-termos/${this.user.id_usuario}`)
        .then(response => {
          if (response) {
            this.dialog_termos = false;
          }
          this.dialog_termos = false;
          if (this.user.clubes.length > 1) {
            this.dialog_clubes = true;
          } else {
            localStorage.setItem("token", this.user.clubes[0].clube_token);
            localStorage.setItem("clubes", JSON.stringify(this.user.clubes));
            localStorage.setItem("user-token", this.user.usuario_token);
            localStorage.setItem("tkn", "1");

            localStorage.setItem(
              "clube-atual",
              JSON.stringify(this.user.clubes[0])
            );
            if (!this.modulos_login.some(item => item.id_modulo == 1)) {
              this.$router.push({ name: "Meu_titulo" });
            } else {
              this.$router.push({ name: "Dashboard" });
            }
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },

    continuarLogin(item) {
      this.loadingContinuar = true;
      if (item.clube_token) {
        localStorage.setItem("clubes", JSON.stringify(this.user.clubes));
        localStorage.setItem("token", item.clube_token);
        localStorage.setItem("user-token", this.user.usuario_token);
        localStorage.setItem("clube-atual", JSON.stringify(item));
        localStorage.setItem("tkn", "1");
        //this.dialog_clubes = false;
        if (!item.modulos.some(id => id.id_modulo == 1)) {
          this.$router.push({ name: "Meu_titulo" });
        } else {
          this.$router.push({ name: "Dashboard" });
        }
      }
    },
    validarSlug() {
      this.loadingValidSlug = true;
      Api.get(`/clubes/valid-slug/${this.clubeSlug}`)
        .then(response => {
          this.loadingValidSlug = false;
          if (response.data.error) {
            this.validSlug = false;
          } else {
            this.validSlug = true;
            this.clube = response.data;
          }
        })
        .catch(err => {
          this.loadingValidSlug = false;
          this.clube = "";
          throw err;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.fundo {
  background-image: url("../assets/fundo.jpg") !important;
}
</style>